var site = site || {};
var generic = generic || {};
var prodcat = prodcat || {};
window.pwr = window.pwr || function () {
  (pwr.q = pwr.q || []).push(arguments);
};
var pr_loyaltymember2, pr_bbclubmember2;

(function ($) {
  Drupal.behaviors.writeReview = {
    renderForm: function (args) {
      var context = args.context;
      var user = args.user;
      var settings = args.settings;
      var isMobile = site.client.isMobile;
      var chatReviewSettings = settings.power_reviews.chat;
      var powerReviewMerchantIds;
      var powerReviewLocale;
      var powerReviewMerchantId;
      var thisLocale;
      var locale;

      if (
        typeof pwr !== 'undefined' &&
        typeof Drupal.settings.power_reviews !== 'undefined' &&
        typeof generic !== 'undefined' &&
        typeof generic.env !== 'undefined' &&
        typeof generic.env.query !== 'undefined' &&
        typeof context !== 'undefined'
      ) {
        var product_id = $('.js-product', context).data('product-id');
        var $writeReviewContainer = $('#power_review_container', context);
        var prLocale, prMerchantId, prLocaleMerchantId;

        product_id = 'PROD' + generic.env.query('pr_page_id');
        var params = [
          {
            products: [product_id],
            query_key: 'product-quickview'
          }
        ];

        generic.jsonrpc.fetch({
          method: 'prodcat.querykey',
          params: params,
          onSuccess: function (t) {
            var productDetails = t.getValue();
            var productName = productDetails.products[0].PROD_RGN_NAME;
            var productURL = productDetails.products[0].url;
            var productLargeImageSrc =
              typeof productDetails.products[0].IMAGE_L === 'object'
                ? productDetails.products[0].IMAGE_L[0]
                : productDetails.products[0].IMAGE_L;
            var productMediumImageSrc =
              typeof productDetails.products[0].IMAGE_M === 'object'
                ? productDetails.products[0].IMAGE_M[0]
                : productDetails.products[0].IMAGE_M;
            var productImageSrc = isMobile ? productMediumImageSrc : productLargeImageSrc;
            var productImageUrl = productDetails.products[0].url;

            $('.js-product-image', $writeReviewContainer).attr('src', productImageSrc);
            $('.js-product-image', $writeReviewContainer).attr('alt', productName);
            $('.js-product-image-link', $writeReviewContainer).attr('href', productImageUrl);
            $('.js-pr-product-name', $writeReviewContainer).html(productName);
            if (Drupal.settings.power_reviews.show_sub_line) {
              var subLine = productDetails.products[0].SUB_LINE;

              $('.js-pr-sub-line', $writeReviewContainer).html(subLine);
            }
            if (
              Array.isArray(Drupal.settings.loyalty_social_earning) &&
              Drupal.settings.loyalty_social_earning.length > 0
            ) {
              generic.jsonrpc.fetch({
                method: 'user.recordSocialAction',
                params: [
                  {
                    action: 'review',
                    url: window.location.origin + productURL || document.referrer
                  }
                ]
              });
            }
          }
        });

        var product = prodcat.data.getProduct(product_id);
        var page_id = generic.env.query('pr_page_id');

        // Bobbibrown CA FR Config Changes
        if (typeof Drupal.settings.power_reviews.merchant_ids !== 'undefined') {
          prLocaleMerchantId = this.getPowerReviewMerchantDetails();
          prLocale =
            document.location.hostname.search('fr.bobbibrowncosmetics.ca') !== -1
              ? Drupal.settings.power_reviews.locale_fr
              : prLocaleMerchantId[0]['locale'];
          prMerchantId =
            document.location.hostname.search('fr.bobbibrowncosmetics.ca') !== -1
              ? Drupal.settings.power_reviews.merchant_id_fr
              : prLocaleMerchantId[0]['merchant_id'];
        } else {
          prLocale =
            document.location.hostname.search('fr.bobbibrowncosmetics.ca') !== -1
              ? Drupal.settings.power_reviews.locale_fr
              : Drupal.settings.power_reviews.locale;
          prMerchantId =
            document.location.hostname.search('fr.bobbibrowncosmetics.ca') !== -1
              ? Drupal.settings.power_reviews.merchant_id_fr
              : Drupal.settings.power_reviews.merchant_id;
        }
        $('#pr-write', context).empty();
        var pr_args = {
          api_key: Drupal.settings.power_reviews.api_key,
          locale: prLocale,
          merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
          merchant_id: prMerchantId,
          page_id: page_id,
          components: {
            Write: 'pr-write'
          }
        };

        if (chatReviewSettings && chatReviewSettings.page_id === page_id) {
          powerReviewMerchantIds = chatReviewSettings.merchant_ids || {};
          powerReviewLocale = chatReviewSettings.locale;
          powerReviewMerchantId = chatReviewSettings.merchant_id;

          if (Object.keys(powerReviewMerchantIds).length > 0) {
            thisLocale = $.cookie('LOCALE') || chatReviewSettings.default_locale;

            for (locale in powerReviewMerchantIds) {
              if (thisLocale === locale) {
                powerReviewLocale = locale;
                powerReviewMerchantId = powerReviewMerchantIds[locale];
                break;
              }
            }
          }

          pr_args = {
            api_key: chatReviewSettings.api_key,
            locale: powerReviewLocale,
            merchant_group_id: chatReviewSettings.merchant_group_id,
            merchant_id: powerReviewMerchantId,
            page_id: page_id,
            components: {
              Write: 'pr-write'
            }
          };
        }

        if (typeof user !== 'undefined' && typeof user.user_id !== 'undefined') {
          pr_args.merchant_user_id = user.user_id;
        }

        pr_loyaltymember2 = '0';
        if (typeof user !== 'undefined' && user.is_loyalty_member) {
          pr_loyaltymember2 = '1';
          pr_bbclubmember2 = $('.js-bbclub-member', context).html();
        }
        pr_args.on_submit = function (config, data) {
          $(window).scrollTop(0);
          $('.js-war-heading', $writeReviewContainer).addClass('hidden');
          if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
            site.track.reviewWriteEnd();
          }
        };
        pr_args.on_render = function () {
          var $reviewContainer = $('.js-pr-write');
          var $emailField = $('#pr-email_collection-input', $reviewContainer);
          var mailValue = $emailField[0].value;
          var tracker = $emailField[0]._valueTracker;
          var userEmail = $('.js-pr-email').eq(0).val();
          var inputEvent = new Event('input', { bubbles: true });

          if (typeof user !== 'undefined' && typeof user.email_address !== 'undefined') {
            $emailField.attr('value', user.email_address);
            tracker.setValue(mailValue);
            $emailField[0].dispatchEvent(inputEvent);
          } else {
            $emailField.attr('value', userEmail)
            tracker.setValue(mailValue);
            $emailField[0].dispatchEvent(inputEvent);
          }
        };
        pwr('render', pr_args);
      }
    },

    attach: function (context, settings) {
      var signedIn = site.userInfoCookie.getValue('signed_in') - 0 === 1;
      var that = this;
      var appName = generic.env.query('appName');
      var chatReviewSettings = settings.power_reviews && settings.power_reviews.chat;
      var pageId = generic.env.query('pr_page_id');
      var $powerReviewContainer = $('.js-power-review-container', context);

      if (chatReviewSettings && chatReviewSettings.page_id === pageId) {
        $powerReviewContainer.addClass('chat-power-review-container');
      }

      if (appName === 'askQuestion') {
        $('.email_check .js-review-title').addClass('hidden');
        $('.email_check .js-question-title').removeClass('hidden');
      }
      if (signedIn) {
        $(document).on('user.loaded', function (e, user) {
          that.renderForm({
            context: context,
            user: user,
            settings: settings
          });
        });
      } else {
        var page_id = generic.env.query('pr_page_id');

        if (
          typeof Drupal.settings.power_reviews.full_login !== 'undefined' &&
          Drupal.settings.power_reviews.full_login
        ) {
          var returnUrl = encodeURIComponent(document.location.pathname + '?page_id=' + page_id);
          var signinUrl = '/account/signin.tmpl' + '?RETURN_URL=' + returnUrl;

          document.location.href = signinUrl;
        }
        $('#pwr_signin', context).removeClass('hidden');
        var pr_valid_email = $('#pr_valid_email', context).html();
        // get product details to show in login page
        var params = [
          {
            products: ['PROD' + page_id],
            query_key: 'product-quickview'
          }
        ];

        generic.jsonrpc.fetch({
          method: 'prodcat.querykey',
          params: params,
          onSuccess: function (t) {
            var productDetails = t.getValue();
            var productImageSrc = productDetails.products[0].IMAGE_L[0];
            var productName = productDetails.products[0].PROD_RGN_NAME;
            var productImageUrl = productDetails.products[0].url;

            $('#pwr_signin .js-product-image').attr('src', productImageSrc);
            $('#pwr_signin .js-product-image').attr('alt', productName);
            $('#pwr_signin .js-product-image').attr('title', productName);
            $('#pwr_signin .js-product-image-link').attr('href', productImageUrl);
          }
        });
        // check whether registered user
        $('.email_check .btn-pr').click(function (evt) {
          evt.preventDefault();
          $(this).attr('disabled', true);
          var email = $('.pr_email').val();

          if (that.isValidEmailAddress(email)) {
            generic.jsonrpc.fetch({
              method: 'user.registered',
              params: [{ email_address: email }],
              onSuccess: function (r) {
                $('.js-signin-err-msg', context).empty().addClass('hidden');
                var val = r.getValue();
                var isUser = val !== null && val === 1;

                if (isUser) {
                  // show full login
                  $('#pwr_signin .email_check').addClass('hidden');
                  $('#pwr_signin .full_sign_in').removeClass('hidden');
                  $('#pwr_signin input[name="EMAIL_ADDRESS"]').val(email);
                } else {
                  // anonymous write-a-review
                  that.triggerSignin({
                    context: context,
                    signinRequest: 0,
                    settings: settings
                  });
                }
              }
            });
          } else {
            $('.js-signin-err-msg', context).empty().html(pr_valid_email).removeClass('hidden');
            $(this).attr('disabled', false);
          }
        });
        $('.full_sign_in .btn-pr').click(function (evt) {
          evt.preventDefault();
          var email = $('#js-signin-form input[name="EMAIL_ADDRESS"]').val();

          if (that.isValidEmailAddress(email)) {
            $(this).attr('disabled', true);
            $('.js-signin-err-msg', context).empty().addClass('hidden');
            that.triggerSignin({
              context: context,
              signinRequest: 1,
              settings: settings
            });
          } else {
            $(this).attr('disabled', false);
            $('.js-signin-err-msg', context).empty().html(pr_valid_email).removeClass('hidden');
          }
        });
        $('.full_sign_in .js-forgot-password').click(function (evt) {
          evt.preventDefault();
          var email = $('#js-signin-form input[name="EMAIL_ADDRESS"]').val();

          site.signin.requestPassword(email);
        });
      }
    },
    triggerSignin: function (args) {
      var context = args.context;
      var signinRequest = args.signinRequest;
      var settings = args.settings;
      var that = this;
      var paramObj = {};

      if (signinRequest) {
        var inputVals = $('#power_review_container', context)
          .find('#js-signin-form')
          .serializeArray();

        // loop through all the fields and get the values
        $.each(inputVals, function (index, formObj) {
          paramObj[formObj.name] = formObj.value;
        });
      } else {
        var email = $('.pr_email', context).val();

        paramObj.NEW_USER_EMAIL_ADDRESS = email;
        paramObj._SUBMIT = 'signin_new_user';
        paramObj._SECONDARY_SUBMIT = 'email_promotions';
        paramObj.PC_EMAIL_PROMOTIONS = 0;
      }
      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [paramObj],
        onSuccess: function (r) {
          var userInfo = r.getData().userinfo;

          $('.js-signin-err-msg', context).empty().addClass('hidden');
          $('#pwr_signin', context).addClass('hidden');
          that.renderForm({
            context: context,
            user: userInfo,
            settings: settings
          });
        },
        onFailure: function (r) {
          var messages = r.getMessages();
          var key = messages[0].key;
          var offer_only_errors = 1;

          $.each(messages, function (key, message) {
            if ($.inArray('offers', message.tags) === -1) {
              offer_only_errors = 0;
            }
          });
          if (offer_only_errors === 1) {
            var userInfo = r.getData().userinfo;

            $('.js-signin-err-msg', context).empty().addClass('hidden');
            $('#pwr_signin', context).addClass('hidden');
            that.renderForm({
              context: context,
              user: userInfo,
              settings: settings
            });
          } else {
            var $gdprError = $('.js-gdpr-signin-err-msg', context);
            var $signinError = $('.js-signin-err-msg', context);

            if (key.match(/format.password/i) && $gdprError.html().length) {
              $gdprError.removeClass('hidden');
              $signinError.addClass('hidden');
            } else {
              $signinError.empty().html(messages[0].text).removeClass('hidden');
              $gdprError.addClass('hidden');
            }
            $('.btn-pr', '.full_sign_in').attr('disabled', false);
          }
        }
      });
    },
    isValidEmailAddress: function (emailAddress) {
      var atpos = emailAddress.indexOf('@');
      var dotpos = emailAddress.lastIndexOf('.');

      return atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailAddress.length ? false : true;
    },
    getPowerReviewMerchantDetails: function () {
      var prMerchantId = Drupal.settings.power_reviews.merchant_ids;
      var locale =
        $.cookie('LOCALE') !== null && $.cookie('LOCALE') !== ''
          ? $.cookie('LOCALE').toLowerCase()
          : Drupal.settings.power_reviews.default_locale;
      var prLocaleMerchantId = [];

      if (typeof prMerchantId[locale] !== 'undefined') {
        $.each(prMerchantId[locale], function (locale, merchantId) {
          prLocaleMerchantId.push({
            locale: locale,
            merchant_id: merchantId
          });
        });
      }

      return prLocaleMerchantId;
    }
  };
})(jQuery);
